import { useEffect, useState } from "react";
import { GetTruckListReqQuery } from "../types/truckContract";
import { Truck } from "../types/truck";
import apiGetTruckList from "../api/truck/apiGetTruckList";
import { useAppContext } from "../contexts/DataContext";
import { useDisplayContext } from "../contexts/DisplayContext";
import { useLoadingContext } from "../contexts/LoadingContext";
import { ErrorI } from "../types/api";

const useTruckList = (query?: GetTruckListReqQuery) => {
  const { incrementLoading, decrementLoading } = useLoadingContext()
  const { notify } = useDisplayContext();
  const { dispatch } = useAppContext();
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState<Truck[]>([]);

  useEffect(() => {
    isLoading ? incrementLoading() : decrementLoading();
  }, [isLoading])

  const get = async (newQuery?: GetTruckListReqQuery) => {
    if (newQuery) query = newQuery;

    let resData: Truck[] | undefined = undefined;
    let error: ErrorI | undefined = undefined;

    try {
      setIsLoading(true);

      const res = await apiGetTruckList(query);

      setData(res.json.data);

      dispatch({
        type: "GET",
        payload: {
          type: "trucks",
          data: res.json.data,
        },
      });

      resData = res.json.data;
    } catch (err) {
      // TODO!: error handler
      console.error(err);
      if ("message" in (err as ErrorI)) {
        error = err as ErrorI;
      }
      notify.error("Gagal mendapatkan data Truk")
    } finally {
      setIsLoading(false);
    }

    return { resData, error };
  };

  return {
    data,
    isLoading,
    get,
  };
};

export default useTruckList;
